<template>
  <div>
    <div class="pairedForms" v-for="(row, index) in rows" :key="index">
      <div class="form__half">
        <tooltip v-show="index === 0 && filedErrors.hasOwnProperty('unit_type')" class="form__validation">
          {{ $t('errors.field_required') }}
        </tooltip>
        <div class="label" v-if="index === 0">{{ $t('ticket_types.unit_type') }} *</div>
        <el-select class="w95" v-model="row.type" @change="updateData">
          <el-option value="hour" label="Hour" />
          <el-option value="day" label="Day" />
          <el-option value="week" label="Week" />
          <el-option value="month" label="Month" />
        </el-select>
      </div>
      <div class="form__half ar">
        <tooltip v-show="index === 0 && filedErrors.hasOwnProperty('unit_price')" class="form__validation">
          {{ $t('errors.field_required') }}
        </tooltip>
        <div class="label w95" v-if="index === 0">{{ $t('ticket_types.unit_price') }} *</div>
        <input type="text" class="w95" v-model="row.price" @input="updateData" @blur="cleanupRows" />
      </div>
    </div>
    <div v-if="rows.length < 2" style="margin-top: 10px;">
      <el-button type="primary" size="small" @click.prevent="addRow">Add time unit</el-button>
    </div>
  </div>
</template>

<script>

import '../../styles.scss'
import {storeMixin} from '../../mixins/storeMixin.js'
import {mapGetters} from "vuex";
import Tooltip from "../../../../common/Tooltip";

export default {
  mixins: [storeMixin],
  props: ['subData'],
  components: {
    Tooltip
  },
  data() {
    return {
      rows: []
    }
  },
  created() {
    this.initRows()
  },
  computed: {
    ...mapGetters({
      filedErrors: 'tenants/ticketTypes/filedErrors',
    })
  },
  methods: {
    initRows() {
      if (this.subData) {
        let types = [];
        let prices = [];

        if (this.subData.time_pickers && Array.isArray(this.subData.time_pickers)) {
             this.subData.time_pickers.forEach(picker => {
                 types.push(picker.unit_type);
                 prices.push(picker.unit_price / 100);
             });
        } else {
            // Fallback to legacy
            let t = this.subData.unit_type;
            let p = this.subData.unit_price;

            if (!Array.isArray(t)) {
              t = (t !== null && t !== undefined) ? [t] : [];
            }
            if (!Array.isArray(p)) {
              p = (p !== null && p !== undefined) ? [p] : [];
            }

            types = t;
            prices = p.map(val => val / 100);
        }

        const maxLen = Math.max(types.length, prices.length);
        for (let i = 0; i < maxLen; i++) {
          this.rows.push({
            type: types[i] || '',
            price: (prices[i] !== null && prices[i] !== undefined) ? prices[i] : ''
          });
        }
      }

      if (this.rows.length === 0) {
        this.rows.push({ type: '', price: '' });
      }

      // Sync initial rows to store immediately
      this.updateData();
    },
    addRow() {
      if (this.rows.length < 2) {
        this.rows.push({ type: '', price: '' });
        this.updateData();
      }
    },
    updateData() {
      const types = this.rows.map(r => r.type);
      const prices = this.rows.map(r => r.price);

      this.setTicketData('unit_type', types);
      this.setTicketData('unit_price', prices);
    },
    cleanupRows() {
      // Filter out rows where price is empty, but keep at least one row
      if (this.rows.length > 1) {
        this.rows = this.rows.filter(row => row.price !== '' && row.price !== null && row.price !== undefined);

        if (this.rows.length === 0) {
             this.rows.push({ type: '', price: '' });
        }

        this.updateData();
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tenants/ticket-types/ui/ExtraFields/picker.vue